import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { ActiontrackerService } from '../../../actiontracker/services/actiontracker.service';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { DashboardFilter } from '../../../shared/models/dashboardFilter.model';
import { BaseService } from '../../../shared/services/base.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { Task } from '../../model/task.model';
import { TaskConstantsService } from '../../services/task-constants.service';
import { TaskService } from '../../services/task.service';

@Component({
  selector: 'ara-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})
export class TaskListComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  taskListResponse: any[] = [];
  Task = new Task();
  status: any[];
  display: boolean = false;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  monitoringMatrixNames: any[];
  searchText: string = '';
  taskOverviewFilter: DashboardFilter;
  itemsPerPage: number = 50;
  rowCount: number;
  pageSize: number = 1;
  searchModified: boolean = false;
  hideFilter: boolean;
  hideSort: boolean;
  columnList: { key: string; value: string; }[];
  jsonString: string;
  loggedInUserJSON: any;
  taskSectionResponse: any[] = [];
  filterData: any[] = [];
  selectedMonitoringMatrix: number[] = [];
  fromDate: Date = null;
  toDate: Date = null;
  selectedTask: any;
  contextItems: MenuItem[] = [];
  taskIds: number[];
  alertType: string;
  successDetails: string;
  errorDetails: string;
  confirmMessage: string;
  row: HTMLElement;
  isTasksChecked: boolean = true;
  window = window;
  checked: any;
  unitList: any[];
  selectedUnit: any[];
  zip: any;
  itemsToProcess: any;
  itemsProcessed: number;
  taskSourceIds: any;
  currentSourceRowCount: number;
  taskStatus: any[];
  selectedStatusId: any[];
  permissions: any;
  currentId: number;
  sectionList:any[] = [];
  selectedSection:any[] =[];
  disableExport: boolean = false;

  constructor(private taskService: TaskService,
    public baseService: BaseService, private masterscreenService: MasterscreenService,
    private translate: TranslateService, private notificationsService: NotificationsService,
    private actionTrackerService: ActiontrackerService) {
    this.taskListResponse = [];
    this.Task.RecurrenceDate = new Date();
    this.status = [
      { label: 'Active', value: false },
      { label: 'InActive', value: true },
    ];
  }

  ngOnInit() {
    this.baseService.showRootLoader = true;
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openTask()
      }];
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    let routes = JSON.stringify(TaskConstantsService.TaskNavigation.InnerRoutes);
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = TaskConstantsService.TaskNavigation.ReportRoutes;
    this.taskOverviewFilter = new DashboardFilter();
    this.getProcess();
    this.permissions = JSON.parse(this.baseService.getItemFromSession('UserIndependentPermissions'));
    if (!this.permissions.TSK_Add && !this.permissions.TSK_Add_Unit && !this.permissions.TSK_Admin && !this.permissions.TSK_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === "Task Setup") {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
  getProcess() {
    this.actionTrackerService.getProcess(this.callbackMethodForgetProcess.bind(this));
  }
  callbackMethodForgetProcess(response) {
    if (response.Success) {
      response.Result.forEach(process => {
        if (process.ProcessName === 'Task') {
          this.getStatusByProcessId(process.ProcessId);
        }
      });
    }
  }
  getStatusByProcessId(processId) {
    const apiRequest = {
      Model: {
        ProcessId: processId
      }
    };
    this.actionTrackerService.getStatusByProcessId(apiRequest, this.callbackMethodForgetStatus.bind(this));
  }
  callbackMethodForgetStatus(response) {
    this.taskStatus = [];
    this.selectedStatusId = [];
    if (response.Success) {
      response.Result.forEach(element => {
        if (element.StatusName === TaskConstantsService.Status.New
          ||element.StatusName === TaskConstantsService.Status.Draft) {
          this.taskStatus.push({
            label: element.StatusName,
            value: element.StatusId,
            checked: true
          });
          this.selectedStatusId.push(element.StatusId);
        }
      });
      if (this.permissions.SUPER_Admin) {
        response.Result.forEach(element => {
          if (element.StatusName === TaskConstantsService.Status.Cancelled ||
            element.StatusName === TaskConstantsService.Status.Deleted) {
            this.taskStatus.push({
              label: element.StatusName,
              value: element.StatusId,
              checked: true
            });
            this.selectedStatusId.push(element.StatusId);
          }
        });
      }
    }
    this.getSectionData();
  }
  getSectionData() {
    const apiRequest = {
      Model: {
        MatrixId: [0]
      }
    }
    this.taskService.getTask(apiRequest, this.callbackMethodForGetTaskSection.bind(this));
  }
  callbackMethodForGetTaskSection(response) {
    if (response.Success && response.Result.length > 0) {
      this.taskSectionResponse = response.Result;
      this.sectionList = [];
      this.taskSectionResponse.forEach(element => {
        this.sectionList.push({
          'label': element.SectionName,
          'value': element.SectionId
        })
        this.selectedSection.push(element.SectionId);
      });
    }
    this.masterscreenService.getAllMonitoringMatrixName(null, this.callbackMethodForGetAllMonitoringMatrixName.bind(this));
  }
  callbackMethodForGetAllMonitoringMatrixName(response) {
    this.monitoringMatrixNames = [];
    response.Result.forEach(element => {
      this.monitoringMatrixNames.push({
        'label': element.MatrixName,
        'value': element.MatrixId
      })
      this.selectedMonitoringMatrix.push(element.MatrixId);
    });
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      }
    }
    this.masterscreenService.getUnits(apiRequestUnit, this.callbackMethodForUnitDetails.bind(this));
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      this.selectedUnit = [];
      unitDetails.forEach((unit) => {
        this.unitList.push(
          {
            'label': unit.UnitName,
            'value': unit.UnitId,
            'checked': true
          }
        );
        this.selectedUnit.push(unit.UnitId);
      });
    }
    this.getTaskListData();
  }
  getTaskListData() {
    this.baseService.showRootLoader = true;
    if (!this.taskOverviewFilter.OrderdByColoumName) {
      this.taskOverviewFilter.OrderdByColoumName = TaskConstantsService.ColumnNames.TaskId;
    }
    if (!this.taskOverviewFilter.OrderdBy) {
      this.taskOverviewFilter.OrderdBy = TaskConstantsService.ColumnNames.DESC;
    }
    if (!this.selectedUnit.length) {
      this.unitList.forEach(element => {
        this.selectedUnit.push(element.value);
      });
    }
    if (!this.selectedMonitoringMatrix.length) {
      this.monitoringMatrixNames.forEach(element => {
        this.selectedMonitoringMatrix.push(element.value);
      });
    }
    if (!this.selectedSection.length) {
      this.sectionList.forEach(element => {
        this.selectedSection.push(element.value);
      });
    }
    this.taskOverviewFilter.UserId = this.loggedInUserJSON.UserId;
    if (!this.rowCount) {
      this.rowCount = this.itemsPerPage * 2;
    }
    this.taskOverviewFilter.PageSize = this.itemsPerPage;
    this.taskOverviewFilter.CurrentPage = !this.pageSize ? 1 : this.pageSize;
    this.taskOverviewFilter.MonitoringMatrixFilter = this.selectedMonitoringMatrix;
    this.taskOverviewFilter.SectionFilter = this.selectedSection;
    this.taskOverviewFilter.FromDate = this.fromDate == null ? new Date(0) : moment(this.fromDate).startOf('day').toDate();
    this.taskOverviewFilter.ToDate = this.toDate == null ? new Date() : moment(this.toDate).endOf('day').toDate();
    this.taskOverviewFilter.Units = this.selectedUnit;
    this.taskOverviewFilter.StatusId = this.selectedStatusId;
    if (this.taskOverviewFilter.RecurrenceType === '2') {
      this.taskOverviewFilter.RecurrencePeriod = null;
    }
    this.taskOverviewFilter.SelectAll = this.isTasksChecked;
    const filter = JSON.parse(this.baseService.getFilterData('taskFilter'));
    if (!this.searchModified && filter) {
      this.taskOverviewFilter = filter;
      this.pageSize = filter.CurrentPage;
      this.searchText = filter.SearchText;
      this.selectedMonitoringMatrix = filter.MonitoringMatrixFilter;
      this.selectedSection = filter.SectionFilter;
      this.fromDate = filter.FromDate === null ? filter.FromDate : new Date(filter.FromDate);
      this.toDate = filter.ToDate === null ? filter.ToDate : new Date(filter.ToDate);
      this.isTasksChecked = filter.SelectAll;
      this.selectedUnit = filter.Units;
      this.selectedStatusId = filter.StatusId;
      if (!this.taskService.getAllTaskIds()) {
        this.isTasksChecked = true;
        this.taskOverviewFilter.SelectAll = true;
      }
      if (this.pageSize === 1) {
        this.taskOverviewFilter.PageIndex = 0;
      } else {
        this.taskOverviewFilter.PageIndex = ((this.pageSize * this.itemsPerPage) - this.itemsPerPage);
        this.rowCount = ((this.pageSize + 1) * this.itemsPerPage);
      }
    } else {
      this.baseService.setFilterData('taskFilter', JSON.stringify(this.taskOverviewFilter));
    }
    this.taskOverviewFilter.UserId = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: this.taskOverviewFilter
    }
    this.taskService.getTaskList(apiRequest, this.callbackMethodForGetTaskList.bind(this));
  }
  callbackMethodForGetTaskList(response) {
    this.taskListResponse = [];
    
    if (response.Success && response.Result.length > 0) {
        //BOC Pritesh
       response.Result.forEach((element,index) => {
       if(element.Status ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
       {
         response.Result.splice(index,1);
       }
     });    
      //EOC Pritesh
      this.taskListResponse = response.Result;
      if (this.taskOverviewFilter.SelectAll && !this.searchModified) {
        this.selectAllTasks(this.taskOverviewFilter.SelectAll);
      } else if (this.searchModified) {
        this.taskOverviewFilter.SelectAll = true;
        this.taskService.setAllTaskIds([]);
        this.selectAllTasks(this.taskOverviewFilter.SelectAll);
      } else {
        if (this.taskService.getAllTaskIds()) {
          this.taskListResponse.forEach(element => {
            this.taskService.getAllTaskIds().forEach(stored => {
              if (element.TaskId === stored) {
                element.Checked = true;
              }
            });
          });
        }
      }
      this.taskListResponse.forEach((taskListResponseElement) => {
        this.taskSectionResponse.forEach(taskDetailsResponseElement => {
          if (taskDetailsResponseElement.SectionId === taskListResponseElement.SectionId) {
            taskListResponseElement.SectionName = taskDetailsResponseElement.SectionName
          }
        });
        if (taskListResponseElement.IsActive === true) {
          taskListResponseElement.IsActive = 'ON';
        } else {
          taskListResponseElement.IsActive = 'OFF';
        }
        this.monitoringMatrixNames.forEach(element => {
          if (element.value === taskListResponseElement.MatrixId) {
            taskListResponseElement.MatrixName = element.label;
          }
        });
      });
    } else {
      this.baseService.processApiResponseError(response);
    }
    if (!response.Result || response.Result.length < this.itemsPerPage) {
      this.rowCount = this.rowCount - this.itemsPerPage;
    }
    this.getAllTaskIds();
    this.baseService.showRootLoader = false;
  }
  getServerData(event) {
    if (event === 1) {
      this.taskOverviewFilter.PageIndex = 0;
    } else {
      this.taskOverviewFilter.PageIndex = ((event * this.itemsPerPage) - this.itemsPerPage);
      this.rowCount = ((event + 1) * this.itemsPerPage);
    }
    this.taskOverviewFilter.CurrentPage = event;
    this.pageSize = event;
    this.searchModified = true;
    this.getTaskListData();
  }
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }
  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }
  searchData() {
    this.taskOverviewFilter.SearchText = this.searchText;
    this.searchModified = true;
    this.isTasksChecked = true;
    this.getTaskListData();
    this.taskService.setAllTaskIds([]);
  }
  doneFilter() {
    this.searchModified = true;
    if (this.rowCount === 50) {
      this.rowCount = this.rowCount * 2;
    }
    this.searchModified = true;
    this.taskOverviewFilter.PageSize = this.itemsPerPage;
    this.taskOverviewFilter.PageIndex = 0;
    this.pageSize = 1;
    this.rowCount = null;
    this.isTasksChecked = true;
    this.taskOverviewFilter.MonitoringMatrixFilter = this.selectedMonitoringMatrix;
    this.getTaskListData();
    this.taskService.setAllTaskIds([]);
    this.hideFilter = false;
  }

  resetValue() {
    this.searchModified = true;
    this.taskOverviewFilter.RecurrenceType = "0";
    this.taskOverviewFilter.RecurrencePeriod = null;
    this.fromDate = null;
    this.toDate = null;
    this.taskOverviewFilter.FromDate = null;
    this.taskOverviewFilter.ToDate = null;
    this.selectedUnit = [];
    this.selectedMonitoringMatrix = [];
    this.isTasksChecked = true;
    this.selectedStatusId = [];
    this.selectedSection = [];
    this.taskStatus.forEach(status => {
      this.selectedStatusId.push(status.value);
    })
    this.getTaskListData();
    this.taskService.setAllTaskIds([]);
  }
  clearSearch() {
    this.searchText = '';
    this.taskOverviewFilter.SearchText = this.searchText;
    this.searchModified = true;
    this.getTaskListData();
    this.taskService.setAllTaskIds([]);
  }
  ascTaskId() {
    this.taskOverviewFilter.OrderdByColoumName = TaskConstantsService.ColumnNames.TaskId;
    this.taskOverviewFilter.OrderdBy = TaskConstantsService.ColumnNames.ASC;
    this.taskOverviewFilter.PageIndex = 0;
    this.taskOverviewFilter.PageSize = 50;
    this.pageSize = 1;
    this.searchModified = true;
    this.getTaskListData();
  }
  descTaskId() {
    this.taskOverviewFilter.OrderdByColoumName = TaskConstantsService.ColumnNames.TaskId;
    this.taskOverviewFilter.OrderdBy = TaskConstantsService.ColumnNames.DESC;
    this.taskOverviewFilter.PageIndex = 0;
    this.taskOverviewFilter.PageSize = 50;
    this.pageSize = 1;
    this.searchModified = true;
    this.getTaskListData();
  }
  ascTaskDate() {
    this.taskOverviewFilter.OrderdByColoumName = TaskConstantsService.ColumnNames.CreatedDate;
    this.taskOverviewFilter.OrderdBy = TaskConstantsService.ColumnNames.ASC;
    this.taskOverviewFilter.PageIndex = 0;
    this.taskOverviewFilter.PageSize = 50;
    this.pageSize = 1;
    this.searchModified = true;
    this.getTaskListData();
  }
  descTaskDate() {
    this.taskOverviewFilter.OrderdByColoumName = TaskConstantsService.ColumnNames.CreatedDate;
    this.taskOverviewFilter.OrderdBy = TaskConstantsService.ColumnNames.DESC;
    this.taskOverviewFilter.PageIndex = 0;
    this.taskOverviewFilter.PageSize = 50;
    this.pageSize = 1;
    this.searchModified = true;
    this.getTaskListData();
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Download is in Progress!');
    let filter = JSON.parse(this.baseService.getFilterData('taskFilter'));
    filter.SourceIds = [];
    this.taskService.getAllTaskIds().forEach(element => {
      filter.SourceIds.push(element);
    });
    const apiRequest = {
      Model: filter
    }
    this.taskService.ExportToExcelTaskList(apiRequest, this.callbackMethodForExportGetTaskList.bind(this));
  }
  callbackMethodForExportGetTaskList(response) {
    if(response.Success){
      response.Result.forEach((taskListResponseElement) => {
        this.taskSectionResponse.forEach(taskDetailsResponseElement => {
          if (taskDetailsResponseElement.SectionId === taskListResponseElement.SectionId) {
            taskListResponseElement.SectionName = taskDetailsResponseElement.SectionName
          }
        });
        if (taskListResponseElement.IsActive === true) {
          taskListResponseElement.IsActive = 'ON';
        } else {
          taskListResponseElement.IsActive = 'OFF';
        }
        this.monitoringMatrixNames.forEach(element => {
          if (element.value === taskListResponseElement.MatrixId) {
            taskListResponseElement.MatrixName = element.label;
          }
        });
      });
      response.Result.forEach(element => {
        element.TaskName = element.Name;
      });
      this.columnList = [
        { key: "TaskId", value: "Task ID" },
        { key: "UnitName", value: "Unit" },
        { key: "ContractNumber", value: "Contract Number" },
        { key: "ContractHolderName", value: "Contract Holder" },
        { key: "TaskName", value: "Task Name" },
        { key: "MatrixName", value: "Matrix Name" },
        { key: "SectionName", value: "Section Name" },
        { key: "RecurrencePeriod", value: "Recurrence Period" },
        { key: "IsActive", value: "Task Status" },
        { key: "CreatedDate", value: "Created Date" },
      ];
      const parsedResponse: any = FileUtility.convertToCSV(response.Result, this.columnList);
      FileUtility.downloadCSV(parsedResponse, 'TaskReport.csv');
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  showAllTasks(event) {
    this.searchModified = true;
    this.getTaskListData();
  }
  recurrenceTypeChanged() {
    this.searchModified = true;
  }
  showContextMenu(task) {
    this.selectedTask = task.TaskId;
  }
  openTask() {
    window.open('/task/create-task/' + this.selectedTask, '_blank')
    this.contextMenu.hide();
  }
  getAllTaskIds() {
    let filter = JSON.parse(this.baseService.getFilterData('taskFilter'));
    filter.PageIndex = 0;
    filter.PageSize = 10000;
    const apiRequest = {
      Model: filter
    }
    this.taskService.getTaskList(apiRequest, this.callbackMethodForGetAllTaskListIds.bind(this));
  }
  callbackMethodForGetAllTaskListIds(response) {
    this.taskIds = [];
    if (response.Result) {
      response.Result.forEach(element => {
        this.taskIds.push(element.TaskId);
      });
    }
    this.taskService.setAllTaskIds(this.taskIds);
  }
  onYesClickedForConfirmation() { }
  onNoClickedForConfirmation() { }
  onOkClicked() { }
  selectTasks(task, event) {
    let tasks = this.taskService.getAllTaskIds();
    if (event.target.checked) {
      tasks.push(task.TaskId);
    } else {
      this.isTasksChecked = false;
      this.taskOverviewFilter.SelectAll = this.isTasksChecked;
      for (let index = 0; index < tasks.length; index++) {
        const element = tasks[index];
        if (task.TaskId === element) {
          tasks.splice(index, 1);
          break;
        }
      }
    }
    this.taskService.setAllTaskIds(tasks);
    this.baseService.setFilterData('taskFilter', JSON.stringify(this.taskOverviewFilter));
  }
  selectAllTasks(checked) {
    let selectedTasks = [];
    this.taskListResponse.forEach(element => {
      if (checked) {
        element.Checked = true;
        selectedTasks = this.taskService.getAllTaskIds();
        if (!selectedTasks) {
          selectedTasks = [];
        }
        selectedTasks.push(element.TaskId);
        this.taskService.setAllTaskIds(selectedTasks);
      } else {
        element.Checked = false;
        this.taskService.setAllTaskIds([]);
      }
    });
    this.taskOverviewFilter.SelectAll = this.isTasksChecked;
    this.baseService.setFilterData('taskFilter', JSON.stringify(this.taskOverviewFilter));
  }
  highlightCurrentSelectedObservation(id) {
    var el = document.getElementById(id);
    while (!this.checked && el !== null) {
      this.checked = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      let currentColor = document.getElementById(id).style.backgroundColor;
      if (currentColor !== null && currentColor !== 'darkgray') {
        document.getElementById(id).style.backgroundColor = 'darkgray';
      }
      el = null;
    }
  }
  getCurrentDOMElementId(id) {
    this.taskService.setcurrentTaskId(id);
    let tasks = this.taskService.getAllTaskIds();
    if (!tasks.find(task => {
      if (task === id) {
        return task;
      }
    })) {
      this.taskListResponse.forEach(element => {
        if (element.TaskId === id) {
          tasks.push(element.TaskId);
          return;
        }
      });
      this.taskService.setAllTaskIds(tasks);
    }
  }
  ngAfterViewChecked() {
    let currentTaskId = this.taskService.getCurrentTaskId();
    if (currentTaskId) {
      this.highlightCurrentSelectedObservation(currentTaskId);
    }
  }
  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    this.taskSourceIds = [];
    this.taskService.getAllTaskIds().forEach(element => {
      this.taskSourceIds.push({
        ProcessName: 'Task',
        SourceId: element,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (this.taskSourceIds.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: this.taskSourceIds
        }
      }
      this.taskService.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }
  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_task.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  downloadPDF(TaskId) {
    this.currentId = TaskId;
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download in progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName: "Task",
        SourceId: TaskId
      }
    };
    this.taskService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }
  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_task" + this.currentId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }
}
